export enum GiftCardMediumEnum {
  ANY = -1,
  DIGITAL = 1,
  PHYSICAL = 2,
  DIGITAL_VOUCHER = 3,
  PHYSICAL_VOUCHER = 4
}

export enum GiftCardMediumNamesEnum {
  ANY = 'All Gift Cards', // => GiftCardMediumEnum.ANY
  DIGITAL = 'Digital Gift Card', // => GiftCardMediumEnum.DIGITAL
  PHYSICAL = 'Physical Gift Card', // => GiftCardMediumEnum.PHYSICAL
  DIGITAL_VOUCHER = 'Digital Gift Voucher',  // => GiftCardMediumEnum.DIGITAL_VOUCHER
  PHYSICAL_VOUCHER = 'Physical Gift Voucher' // => GiftCardMediumEnum.PHYSICAL_VOUCHER
}

export enum GiftCardMediumTextEnum {
  ANY = 'any',
  DIGITAL = 'digital',
  PHYSICAL = 'physical',
  DIGITAL_VOUCHER = 'digital_voucher',
  PHYSICAL_VOUCHER = 'physical_voucher'
}